import { HotelHitContentFooterContainer, ContentContainer, CTAContainer, InfoSection, InfoLabel, PriceSection, PriceInfoText, OriginalPrice, CurrentPrice, PricePerPerson, NoPriceSection } from './styles/hotelHitContentFooter.js';
import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
import Button from '../../Button/Button.js';
import ArrowLink from '../../Link/ArrowLink.js';
import Icon from '../../Icon/Icon.js';
import { USER_INTERFACE_ARROW_04_RIGHT } from '../../IconPath/USER_INTERFACE_ARROW_04_RIGHT.js';

var HotelHitContentFooter = function HotelHitContentFooter(_ref) {
  var _ref$footerContent = _ref.footerContent,
    _ref$footerContent$te = _ref$footerContent.texts,
    buttonText = _ref$footerContent$te.buttonText,
    priceDetailsText = _ref$footerContent$te.priceDetailsText,
    packageInfoText = _ref$footerContent$te.packageInfoText,
    perPersonText = _ref$footerContent$te.perPersonText,
    paxText = _ref$footerContent$te.paxText,
    noPriceText = _ref$footerContent$te.noPriceText,
    priceInfoText = _ref$footerContent$te.priceInfoText,
    _ref$footerContent$pr = _ref$footerContent.prices,
    price = _ref$footerContent$pr.price,
    originalPrice = _ref$footerContent$pr.originalPrice,
    pricePerPerson = _ref$footerContent$pr.pricePerPerson,
    href = _ref.href,
    onOpenPriceDetails = _ref.onOpenPriceDetails,
    onSelect = _ref.onSelect,
    buttonHref = _ref.buttonHref;
  var hasPrice = !!price;
  var isDiscount = !!originalPrice;
  var content = hasPrice ? /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsxs(InfoSection, {
      children: [/*#__PURE__*/jsx(InfoLabel, {
        children: packageInfoText
      }), /*#__PURE__*/jsx(InfoLabel, {
        children: paxText
      }), priceDetailsText && onOpenPriceDetails ? /*#__PURE__*/jsx(ArrowLink, {
        rel: "nofollow",
        onClick: onOpenPriceDetails,
        className: "sg-hotel-hit__arrow-link",
        children: priceDetailsText
      }) : null]
    }), /*#__PURE__*/jsx(PriceSection, {
      children: /*#__PURE__*/jsxs("div", {
        children: [/*#__PURE__*/jsx(PriceInfoText, {
          children: priceInfoText || null
        }), originalPrice ? /*#__PURE__*/jsx(OriginalPrice, {
          children: originalPrice
        }) : null, /*#__PURE__*/jsx(CurrentPrice, {
          isDiscount: isDiscount,
          children: price
        }), pricePerPerson && perPersonText ? /*#__PURE__*/jsxs(PricePerPerson, {
          children: [pricePerPerson, perPersonText]
        }) : null]
      })
    }), /*#__PURE__*/jsx(Icon, {
      path: USER_INTERFACE_ARROW_04_RIGHT,
      size: "xs",
      className: "sg-hotel-hit__icon"
    })]
  }) : /*#__PURE__*/jsx(NoPriceSection, {
    children: noPriceText
  });
  return /*#__PURE__*/jsxs(HotelHitContentFooterContainer, {
    children: [/*#__PURE__*/jsx(ContentContainer, {
      children: content
    }), /*#__PURE__*/jsx(CTAContainer, {
      children: (buttonHref || href || onSelect) && buttonText ? /*#__PURE__*/jsx(Button, {
        onClick: onSelect,
        href: buttonHref || href,
        rel: "nofollow",
        className: "sg-hotel-hit__primary-button",
        theme: "primary",
        children: buttonText
      }) : null
    })]
  });
};
HotelHitContentFooter.defaultProps = {
  footerContent: null,
  href: null,
  onSelect: null,
  onOpenPriceDetails: null,
  buttonHref: null
};
var HotelHitContentFooter$1 = HotelHitContentFooter;

export { HotelHitContentFooter$1 as default };
//# sourceMappingURL=HotelHitContentFooter.js.map
